
const authMode: 'bff' | 'keycloak' = import.meta.env.VITE_AUTH_MODE === 'bff' ? 'bff' : 'keycloak';

const apiUrl = authMode === 'bff' ? '' : import.meta.env.VITE_API_URL || '';
const wsUrl =
  authMode === 'bff'
    ? typeof window !== 'undefined'
      ? window.location.origin
      : ''
    : import.meta.env.VITE_WS_URL || (apiUrl ? apiUrl.replace(/^http/, 'ws') : '');

export function resolveApiUrl(path: string): string {
  if (/^https?:\/\//.test(path)) return path;
  return `${apiUrl}${path}`;
}

export const config = {
  authMode,
  apiUrl,
  wsUrl,
  keycloak: {
    url: import.meta.env.VITE_KEYCLOAK_URL || '',
    realm: import.meta.env.VITE_KEYCLOAK_REALM || 'requiem',
    clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'requiem-orbit',
    redirectUri: import.meta.env.VITE_KEYCLOAK_REDIRECT_URI || '',
  },
} as const;
